module.exports = __webpack_public_path__ + "static/img/yy20.6a218b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy20.png
// module id = VG6L
// module chunks = 1